function Page404 () {
    return (
      <div>
          <h1>Pagina niet gevonden</h1>
          <span>De pagina waar je naar opzoek was, is niet gevonden!</span>
      </div>
    )
}

export default Page404